// extracted by mini-css-extract-plugin
export default {"DynamicText":"Home_DynamicText__bZ7G1","dynamicMovement":"Home_dynamicMovement__Bo-1+","GradientText":"Home_GradientText__nczzk"};